import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AutenticacionService } from './autenticacion.service';
import { SegmentoActividad } from '../_models/segmento-actividad';

@Injectable({
  providedIn: 'root'
})
export class SegmentoActividadesService {
  private rutServiciosRoles = AppSettings.rutServiciosAPL + '/api/segmentosActividades/';

  constructor( private httpClient: HttpClient, private autenticacionService: AutenticacionService ) {
  }

  listado(): Observable<SegmentoActividad[]> {
    return this.httpClient.get( this.rutServiciosRoles ).pipe( map( res => res as SegmentoActividad[] ) );
  }

  obtener( idSegmento: string ): Observable<SegmentoActividad> {
    return this.httpClient.get( this.rutServiciosRoles + idSegmento ).pipe( map( res => res as SegmentoActividad ) );
  }

  obtenerPorSegmento( idSegmento: string ): Observable<SegmentoActividad[]> {
    return this.httpClient.get( this.rutServiciosRoles + 'segmento/' + idSegmento ).pipe( map( res => res as SegmentoActividad[] ) );
  }

  agregar( segmento: SegmentoActividad ): Observable<SegmentoActividad> {
    segmento.auditoriaUsuario = this.autenticacionService.obtenerIdUsuarioLogueado();
    return this.httpClient.post( this.rutServiciosRoles, segmento ).pipe( map( res => res as SegmentoActividad ) );
  }

  actualizar( segmento: SegmentoActividad ): Observable<any> {
    return this.httpClient.put( this.rutServiciosRoles, segmento ).pipe( map( res => res ) );
  }

  bulk( segmentoActividades: SegmentoActividad[] ): Observable<SegmentoActividad[]> {
    segmentoActividades.map( sa => {
      sa.auditoriaUsuario = this.autenticacionService.obtenerIdUsuarioLogueado();
    } );
    return this.httpClient.post( this.rutServiciosRoles + 'bulk', segmentoActividades ).pipe( map( res => res as SegmentoActividad[] ) );
  }

  listadoActividadesOcupacion(idTipoOcupacionConfiguracion: string): Observable<SegmentoActividad[]> {
    return this.httpClient.get( this.rutServiciosRoles + 'tipoOcupacion/' + idTipoOcupacionConfiguracion ).pipe( map( res => res as SegmentoActividad[] ) );
  }

}
